const types = {
  UPDATE_TOAST: "UPDATE_TOAST",
  RESET_TOAST: "RESET_TOAST",
  
};

export default types;
